import React, { FunctionComponent, memo } from 'react';
import { Box } from '@material-ui/core';
import summaryStyles from '../../../../../summary/summarySection/SummaryStyles';
import SelectedSectionName from '../selectedSectionName/SelectedSectionName';
import SelectedAccessoryOption from './SelectedAccessoryOption';
import ICategory from '../../../../../../../../model/ICategory';

export interface ISelectedAccessoryOptionsListProps {
  sectionName: string;
  categories: ICategory[];
}

const SelectedAccessoryOptionsList: FunctionComponent<ISelectedAccessoryOptionsListProps> = memo(
  ({ categories, sectionName }) => {
    const styles = summaryStyles();

    return (
      <Box className={styles.selectionContainer}>
        {categories?.length > 0 && <SelectedSectionName label={sectionName} />}
        {categories?.map(category =>
          category.featuresList?.features.map((feature, index) => (
            <SelectedAccessoryOption key={index} feature={feature} />
          )),
        )}
      </Box>
    );
  },
);

export default SelectedAccessoryOptionsList;
